<template lang="pug">
  div.map-container.navigation-control.routes-map.geo.map-objects
    div.toolbar
      div.line
        h1.title Навигационный контроль
        div
          p Чтобы привязать маршрут нужно указать transport_vendor_id, его можно найти кликнув по маркеру в Нав контроле, будет в желтом окне либо в попапе
          p Сначала надо вбить точки затем нажать рассчитать, после нажатия появится линии и макеры(макреы можно двигать)
          p Если долго считает нажать на Установить Etton Р и нажать на рассчитать снова, ели не помогло писать в телеграм

    div.new-map
      div(ref="map" v-once).bigmap#map

      template
        transition(name="fade")
          div.legend.legend--objects.cuscroll.open
            e-perfect-scrollbar
              div.head
                label API построения маршрутов
                input(
                v-model="osrmApi"
                )
                br
                | нажать установить если маршрут очень долго не появляются на карте
                br
                a(
                @click.stop.prevent="osrmApi='https://router.project-osrm.org/route/v1'"
                ) Установить OSRM Project
                br
                a(
                @click.stop.prevent="osrmApi='http://osrm.tko.etton.ru/route/v1'"
                ) Установить Etton Р
                br
                br
                label Улицы, каждая с новой строки
                br
                | через | можно задать название для поиска координат, например: Спецавтохозяйство|Луганская ул., 5
                br
                textarea(v-model="currentCar.locations" style="resize:both;")
                br
                label Префикс, который добавить впереди
                input(v-model="currentCar.locationPrefix")
                br
                div
                  button(
                  @click.stop.prevent="locationsToPoints()"
                  ) (1) Преобразовать улицы в точки

                label Id машины(transport_vendor_id)
                input(
                v-model="currentCar.transport_vendor_id"
                )
                br

                label Название авто/маршрута
                input(
                  v-model="currentCar.name"
                )
                br

                label Отавание (если не указать. не будет)
                input(
                v-model="currentCar.himanizeLate"
                )
                br

                label Начало работы
                input(
                v-model="currentCar.himanizeStartAt"
                )
                br

                label Окончание работы
                input(
                v-model="currentCar.himanizeEndAt"
                )
                br

                label Прогресс
                input(
                v-model="currentCar.progress"
                placeholder="0"
                )
                | %
                br

                label Обновлено
                input(
                v-model="currentCar.himanizeUpdateAt"
                )
                br

                label Статус
                select(
                v-model="currentCar.status_id"
                )
                  option(
                    v-for="item in carStatuses"
                    :value="item.id"
                  ) {{item.name}}
              div.head
                div Координаты машины
                small машина должна быть как можно ближе к линии, в идеале на ней
                  br
                  input(
                  style="width:120px;"
                  v-model="currentCar.lat"
                  )
                  input(
                  style="width:120px;"
                  v-model="currentCar.lng"
                  )
              div.head
                span Точки
                a(@click.stop.prevent="addWaypoint") Добавить
                a(
                @click="removeAllWaipoints()"
                ) Удалить все
              div.head
                div(
                  v-for="waypoint, index in currentCar.routeData.inputWaypoints"
                )
                  input(
                  style="width:80px;"
                  v-model="currentCar.routeData.inputWaypoints[index][0]"
                  )
                  input(
                  style="width:80px;"
                  v-model="currentCar.routeData.inputWaypoints[index][1]"
                  )
                  input(
                  style="width:160px;"
                  v-if="currentCar.recognizedLocation && currentCar.recognizedLocation[index]"
                  v-model="currentCar.recognizedLocation[index].street"
                  )
                  a(
                    @click="removeWaypoint(index)"
                    title="Удалить"
                  ) X
              div.head
                 button(
                    @click.stop.prevent="calcWaypoint"
                 ) (2) Рассчитать
                 p {{error}}
              div.head
                span Маршрут
                table
                  tr
                    th Улица
                    th Расст
                    th Время
                  template(
                  v-for="instruction, index in currentCar.routeData.instructions"
                  )
                   template(
                   v-if="currentCar.routeData.waypointIndices.indexOf(instruction.index) > -1"
                   )
                    tr(
                    v-if="instruction"
                    )
                      td
                        input(
                        style="width: 190px;"
                        v-model="currentCar.routeData.instructions[index].road"
                        )
                      td
                        input(
                        style="width: 70px;"
                        v-model="currentCar.routeData.instructions[index].distance"
                        )
                      td
                        input(
                        style="width: 70px;"
                        v-model="currentCar.routeData.instructions[index].time"
                        )
              div.head
                button(
                @click.stop.prevent="saveCarWaypoint"
                ) (3) Сохранить

    router-view

</template>

<script>
  import 'leaflet'
  import 'leaflet-routing-machine'
  import 'leaflet-routing-machine/dist/leaflet-routing-machine.css'

  // @bug: https://github.com/Leaflet/Leaflet/issues/4968
  import markerIcon from 'leaflet/dist/images/marker-icon.png'
  import iconShadow from 'leaflet/dist/images/marker-shadow.png'
  let defaultIcon = L.icon({
    iconUrl: markerIcon,
    shadowUrl: iconShadow,
    iconAnchor: [10, 42]
  })
  L.Marker.prototype.options.icon = defaultIcon

  import url from '../../utils/url.js'
  import {MAP, TILE_LAYER} from '../../config/map.js'
  import {POLYGON} from "../../config/polygon";
  import mapMixin from '../../mixins/map-mixin.js'
  import CarDrawer from './utils/CarDrawer'
  import {map as mapEndpoints, mongoApi, dadata} from '../../api/api-endpoints.js'
  import {NavigationControlRoute} from "../../config/mongo";
  import {CAR_STATUSES, DADATA_TOKEN} from "../../config/config";
  import {OBJECT} from "../../utils/map/types";
  import api from '../../api/api'

  export default {
    name: 'route-map',
    data () {

      this.mapLayers = null
      this.map = null

      return {
        error: null,
        legendMode: 'all',
        layers: [],
        osrmApi: 'http://osrm.tko.etton.ru/route/v1',
        currentCar: {
          locationPrefix: 'Оренбург, ',
          locations: `Спецавтохозяйство|Луганская ул., 5
ул. Мусы Джалиля (конечная)|ул. Мусы Джалиля
ул. Мусы Джалиля 1
ул. Мусы Джалиля, 14 (ма-н)|ул. Мусы Джалиля, 14
ул. Павловская 7
ул. Постникова 9Б
ул. Постникова 9Б корп. 2
`,
          recognizedLocation: [],
          himanizeLate: '',
          himanizeStartAt: '',
          himanizeEndAt: '',
          himanizeStatus: 'active',
          transport_vendor_id: '',
          status_id: 1,
          lat: 61.000665,
          lng: 69.04943,
          type: OBJECT.CAR,
          layerConfig: {
            iconType: "transp"
          },
          subLayerConfig: {
            iconType: 'transport'
          },
          routeData: {
            inputWaypoints: [
              [61.001322, 69.056344],
              [61.001042, 69.054825],
              [61.000881, 69.052687],
              [61.000665, 69.049701],
              [61.002743, 69.048950],
              [61.003228, 69.050073],
              [61.001932, 69.043462],
              [61.004178, 69.044225],
              [61.006926, 69.046965],
              [61.004998, 69.041638],
              [61.005705, 69.037695],
              [61.003777, 69.037973],
              [61.000637, 69.037793],
              [61.001745, 69.034344],
              [61.004331, 69.031191],
              [61.006420, 69.030113],
              [61.007349, 69.033212],
              [61.008016, 69.036670],
              [61.008731, 69.039743]
            ],
            instructions: []
          }
        }
      }
    },
    mixins: [mapMixin],
    computed: {
      carStatuses () {
        return CAR_STATUSES
      },
      item () {
        return this.$store.getters.readUrlEndpoint(this.getItemEndpoint(this.$route))
      },
      showMapLegend: {
        get () {
          return this.$store.state.showMapLegend
        },
        set (value) {
          this.$store.commit('mapLegend', value)
        }
      },
      layersConf() {
        return this.getLayersConf()
      },
      mapBorders () {
        return this.$store.getters.readUrlEndpoint(mapEndpoints.mo())
      }
    },
    created () {
      this.markerClickSubs = this.$emitter.listen('marker.click', e => this.onCarMarkerClick(e))
      if (this.item) {
        this.currentCar = Object.assign({}, this.item)
      }
    },
    destroyed () {
      this.markerClickSubs.unsubscribe()
    },
    methods: {
      locationsToPoints: async function () {
        this.removeAllWaipoints()
        const locations = this.currentCar.locations.split("\n")
        this.$bar.start()
        for (let i = 0; i < locations.length; i++) {
          // skeep emty rows
          if (!locations[i]) {
            continue
          }
          let [showedStreet, searchStreet] = locations[i].split('|')
          searchStreet = searchStreet || showedStreet
          let newLoc = {
            latlng: [],
            street: showedStreet,
            suggestStreet: '',
            dadata: {}
          }
          try {
            let data = await this.$store.dispatch('createModel', {
              url: dadata.dadataEndpoint(),
              data: {
                token: DADATA_TOKEN,
                url: dadata.suggestAddress(),
                query: {
                  query: this.currentCar.locationPrefix + searchStreet,
                  count: 1
                }
              }
            })
            if (data.data.suggestions && Array.isArray(data.data.suggestions) && data.data.suggestions[0]) {
              let suggest = data.data.suggestions[0]
              newLoc.suggestStreet = suggest.value
              newLoc.latlng.push(suggest.data.geo_lat)
              newLoc.latlng.push(suggest.data.geo_lon)
              // newLoc.dadata = data.data
            }
            console.log(data)
          } catch (e) {
            this.$e.warningBox('Ошибка в ' + locations[i] + ' ' + e.toString())
          }
          this.currentCar.recognizedLocation.push(newLoc)
        }
        console.log('recognizedLocation', this.currentCar.recognizedLocation)
        this.currentCar.recognizedLocation.forEach(loc => {
          this.currentCar.routeData.inputWaypoints.push(
            loc.latlng
          )
        })
        this.$bar.finish()
      },
      removeAllWaipoints () {
        this.currentCar.routeData.inputWaypoints = []
        this.currentCar.recognizedLocation = []
      },
      removeWaypoint (index) {
        this.currentCar.routeData.inputWaypoints.splice(index, 1)
        this.currentCar.recognizedLocation.splice(index, 1)
      },
      saveCarWaypoint () {
        let storeAction = 'createModel'
        let endpoint = mongoApi.createCollectionItem(NavigationControlRoute)
        if (this.currentCar.id) {
          storeAction = 'updateModel'
          endpoint = mongoApi.updateCollectionItem(NavigationControlRoute, this.currentCar.id)
        }
        const data = Object.assign({}, this.currentCar)
        // dont save dadata
        data.recognizedLocation.forEach((v, i) => {
          data.recognizedLocation[i].dadata = {}
        })
        this.$store.dispatch(storeAction, {
          url: endpoint,
          data
        }).then(r => {
          const {data: {id}} = r
          this.currentCar.id = id
          alert('Saved')
          // this.$router.push({name: 'navigationControl.routes'})
        }).catch(e => {
          alert(e.toString())
        })
      },
      addWaypoint () {
        this.currentCar.routeData.inputWaypoints.push([61.001322, 69.056344])
      },
      calcWaypoint () {
        if (this.osrmApi) {
          this.routerService.options.serviceUrl = `${this.osrmApi}`
        }
        this.error = null
        this.findRouteByWayponts(
          this.currentCar.routeData.inputWaypoints
        )
      },
      createRouteControl () {
        this.routerService = L.Routing.osrmv1({
          serviceUrl: 'http://osrm.tko.etton.ru/route/v1'
        })
        this.control = new L.Routing.Control({
          position: 'topleft',
          language: 'ru',
          routeWhileDragging: true,
          routeDragTimeout: 250,
          showAlternatives: false,
          router: this.routerService,
          createMarker: (i, waypoint) => {
            let name = i
            if (this.currentCar.recognizedLocation && this.currentCar.recognizedLocation[i]) {
              name = this.currentCar.recognizedLocation[i].street
            }
            return new L.Marker(waypoint.latLng, {
              draggable: true,
              icon: new L.DivIcon({
                html: `<p>${name}</p>`
              })
            })
          }
        })
        this.control.addTo(this.map)
        this.control.on('routingerror', (e) => {
          if (e.error && e.error.target && e.error.target.response) {
            if (+e.error.target.status === 429) {
              setTimeout(() => {
                this.findRouteByWayponts(
                  this.currentCar.routeData.inputWaypoints
                )
              }, 3000)
            } else {
              this.error = e.error.target.response
            }
          } else {
            this.error = 'Неизвестная ошибка'
          }
        })
        this.control.on('routingstart', (e) => {
          this.$bar.start()
          console.log('routingstart')
        })
        this.control.on('routesfound', (e) => {
          this.error = null
          this.$bar.finish()
          let route = e.routes[0]
          console.log(route)
          let routeData = {
            coordinates: [],
            instructions: {},
            inputWaypoints: [],
            waypointIndices: []
          }
          route.coordinates.forEach(v => {
            routeData.coordinates.push([v.lat, v.lng])
          })
          routeData.instructions = route.instructions
          route.inputWaypoints.forEach(v => {
            routeData.inputWaypoints.push([v.latLng.lat, v.latLng.lng])
          })
          routeData.waypointIndices = route.waypointIndices
          this.currentCar.routeData = Object.assign({}, routeData)
          console.log(this.currentCar.routeData)
          this.fillInstructionsByLocations()
        })
        if (this.$route.params.id) {
          this.calcWaypoint()
        }
      },
      fillInstructionsByLocations () {
        if (this.currentCar.routeData.instructions) {
          let counter = 0
          this.currentCar.routeData.instructions.forEach((instruction, index) => {
            if (this.currentCar.routeData.waypointIndices.indexOf(instruction.index) > -1) {
              if (this.currentCar.recognizedLocation[counter]) {
                this.currentCar.routeData.instructions[index].road = this.currentCar.recognizedLocation[counter].street
                this.currentCar.routeData.instructions[index].distance = ''
                this.currentCar.routeData.instructions[index].time = ''
              }
              counter++
            }
          })
        }
      },
      findRouteByWayponts (points = []) {
        let waypoints = []
        points.forEach(v => {
          waypoints.push(L.latLng(v))
        })
        this.control.setWaypoints(waypoints)
      },
      getMapConfig(key) {
        return MAP[key]
      },
      getMapPolygon () {
        return POLYGON
      },
      drawTiles () {
        L.tileLayer(TILE_LAYER, {}).addTo(this.map)
      },
      afterMapInit() {
        this.carDrawer = new CarDrawer(this.map, this)
        this.carDrawer.drawMarkers([])
        this.createRouteControl()
      },
      getMarkerHash(marker){
        return `${marker.id},${marker.lat},${marker.lng}`
      },
      /* required for use in map-poup.vue */
      popupIsOpened(markerInfo){
        let usedRoute = url.getPrevOrCurrentRoute(this.$route)

        return usedRoute.query.openedPopupInfo === this.getMarkerHash(markerInfo)
      },
      /* required for use in map-poup.vue */
      registerOpenPopup(markerInfo){
        let openedPopupInfo = this.getMarkerHash(markerInfo)

        this.replaceRoute({openedPopupInfo: openedPopupInfo})
      },
      destroyMap () {
        console.log('destroyed')
        this.$emitter.emit('geo.destroyMap', {})
        // this.map.remove()
        this.map = null
      },
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return mongoApi.getCollectionItem(NavigationControlRoute, route.params.id)
      }
    },
    asyncData ({store, route, fromRoute, methods}) {
      let promises = []

      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: mapEndpoints.mo(),
        fromCache: true
      }))

      if (methods.getItemEndpoint(route)) {
        promises.push(store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getItemEndpoint(route)
        }))
      }

      if(promises.length === 0){
        return Promise.resolve(1)
      }

      return Promise.all(promises)
    }
  };
</script>

<style>
  .leaflet-routing-container{
    display: none;
  }
</style>
